import React from 'react';
import Lottie from 'react-lottie';

interface LottieWrapperProps {
  options: any;
  style?: React.CSSProperties;
  isClickToPauseDisabled?: boolean;
  className?: string;
}

const LottieWrapper: React.FC<LottieWrapperProps> = props => {
  // Use type assertion to bypass the ReactNode compatibility issue
  const LottieComponent = Lottie as any;

  return <LottieComponent {...props} />;
};

export default LottieWrapper;
